import { Box, Skeleton } from '@mui/material'
import { styled } from '@mui/material/styles'

export const PanelWrapper = styled(Box)({
  marginTop: 8,
  padding: 8,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  overflowY: 'scroll',
})

export const PanelContent = styled(Box)({
  width: '100%',
  '&.panel-hidden': {
    display: 'none',
  },
})

export const BtnWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
})

export const SkeletonWrapper = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200], //theme.GREY_SUB,
}))
